import { TextField } from "@mui/material"
import { useTranslation } from "react-i18next"

interface NricNumberFieldProps {
    value: string,
    error: boolean,
    helperText: string,
    onChange: (value: string) => void
}

function NricNumberField(props: NricNumberFieldProps) {
    const { t } = useTranslation(`signup`)
    const { value, error, helperText, onChange } = props

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        return onChange(event.target.value)
    }

    const handleOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        return onChange(event.target.value)
    }

    return (
        <TextField
            fullWidth
            id="nric-input"
            label={t(`nric`)}
            variant="outlined"
            margin="normal"
            value={value.toUpperCase()}
            error={error}
            helperText={helperText ? t(helperText) : ``}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            inputProps={{ textTransform: `uppercase` }}
        />
    )
}

export default NricNumberField
